import { classNames } from "primereact/utils";

import styles from "./form-field.module.scss";
import type { FormFieldViewProps } from "./types-form-field";

export function FormFieldView({
  labelTone,
  labelPosition,
  floatVariant,
  size,
  disabled,
  hasError,
  testId,
  className,
  style,
  rest,
  children,
}: FormFieldViewProps) {
  return (
    <div
      className={classNames(styles.root, className)}
      style={style}
      data-label-tone={labelTone}
      data-field-size={size}
      data-testid={testId}
      {...rest}
      data-label-position={labelPosition}
      data-float-variant={floatVariant}
      data-invalid={hasError || undefined}
      data-disabled={disabled || undefined}
    >
      {children}
    </div>
  );
}
